import { Control } from "react-hook-form";
import { PlanType } from "../../../../apis/subscriptionApi";
import { PlanForm } from "../PlanDrawer.types";
import { SectionId, useSectionContext } from "../hooks/useSectionContext";
import BillingModalSection from "../sections-v2/BillingModalSection";
import ClassesSection from "../sections-v2/ClassesSection";
import SalesSection from "../sections-v2/SalesSection";
import { useCallback, useEffect, useRef } from "react";

export default function PlanModalSections({
  control,
  planType,
}: {
  control: Control<PlanForm>;
  planType: PlanType;
}) {

  const { setActiveSection } = useSectionContext();

  const sectionsRefs = useRef<Map<SectionId, HTMLDivElement>>(new Map());

  const registerSectionRef = useCallback(
    (id: SectionId) => (ref: HTMLDivElement | null) => {
      if (ref) {
        sectionsRefs.current.set(id, ref);
      } else {
        sectionsRefs.current.delete(id);
      }
    },
    [],
  );

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id as SectionId);
          }
        });
      },
      {
        rootMargin: "-30% 0px -35% 0px",
        threshold: 0.1,
        /*
        Defines the viewport: top/right/bottom/left
        Threshold: section is considered "intersecting"
        when at least x% is visible within the viewport.
        */
      },
    );

    Array.from(sectionsRefs.current.values()).forEach((ref) => {
      if (ref) {
        observer.observe(ref);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [setActiveSection]);

  return (
    <div className="tw-flex-1 tw-h-full">
      <div
        id="basic"
        ref={registerSectionRef("basic")}
        className="tw-px-6 tw-pt-4 tw-pb-6"
      >
        <BillingModalSection control={control} planType={planType} />
      </div>
      <div
        id="access"
        ref={registerSectionRef("access")}
        className="tw-px-6 tw-pt-4 tw-pb-6"
      >
        <ClassesSection control={control} planType={planType} />
      </div>
      <div
        id="sales"
        ref={registerSectionRef("sales")}
        className="tw-px-6 tw-pt-4 tw-pb-6"
      >
        <SalesSection control={control} />
      </div>
    </div>
  );
} 